/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonGrey/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ButtonGrey({
  children,
  viewPath = "/DesignSystem/ButtonGrey",
  alignItems = "center",
  onClick,
  marginTop = 0,
  marginLeft = 0,
  marginRight = 0,
  paddingTop = 8,
  paddingBottom = 8,
  paddingLeft = 16,
  paddingRight = 16,
  alignSelf = "auto",
  borderBottomLeftRadius = 5,
  borderBottomRightRadius = 5,
  borderTopLeftRadius = 5,
  borderTopRightRadius = 5,
  width = "auto",
  isDisabled,
  isSelected,
  fontSize = 14,
  text = "Deafult text"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled,isSelected})
  return (<React.Fragment
>
<button
  data-testid="ButtonGrey.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 disabled={isDisabled}
 style={{'--ai-1-Z2ilDOh': alignItems,'--mt-2-Z2ilDOh': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--ml-3-Z2ilDOh': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-4-Z2ilDOh': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--pt-5-Z2ilDOh': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-6-Z2ilDOh': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-7-Z2ilDOh': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-8-Z2ilDOh': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--as-9-Z2ilDOh': alignSelf,'--bblr-11-Z2ilDOh': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-12-Z2ilDOh': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-14-Z2ilDOh': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-15-Z2ilDOh': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--w-16-Z2ilDOh': typeof width === 'number' ? `${width}px` : width,'--bc-10-Z2ilDOh': isSelected ? "rgba(0,0,0, 0.1)" : isHovered ? "rgba(150,150,150, 0.15)" : "transparent",'--bc-13-Z2ilDOh': isSelected ? "rgba(0,0,0, 0.1)" : isHovered ? "rgba(0,0,0, 0)" : "#f2f2f2"}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="ButtonGrey.Text"
  data-view-path={viewPath}
 style={{'--fs-18-Z2ilDOh': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--c-17-Z2ilDOh': isSelected ? "rgba(0,0,0, 1)" : isHovered ? "rgba(0,0,0, 1)" : "#303030"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</button>
{children}
</React.Fragment>)
}